import React from 'react';
import { Check } from 'lucide-react';
import './Agreement.css';
import './Overview.css'; // Reuse generic styles

const Agreement = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <h1>Engagement Agreement</h1>
          <div className="page-meta">SSI/ENG/2026/TWX-001</div>
        </div>
        <div className="status-badge accepted">ACCEPTED</div>
      </div>

      <div className="agreement-card">
        <div className="document-content">
          <p className="doc-paragraph">
            <strong>1. Scope of Services.</strong> Startup Steroid India shall assess eligibility for GUSEC, iHub, and/or the Gujarat Innovators Scheme, prepare application material, and coordinate with the relevant authority on a best-efforts basis.
          </p>
          <p className="doc-paragraph">
            <strong>2. Fee.</strong> ₹9,900 + GST, payable 50% advance / 50% on submission.
          </p>
          <p className="doc-paragraph">
            <strong>3. No Guarantee of Approval.</strong> Approval and disbursement rest solely with the scheme authority. Fees are payable for advisory work performed, irrespective of outcome...
          </p>
        </div>

        <div className="accepted-badge">
          <Check size={14} /> ACCEPTED 30 JUN 2026, 11:42 IST
        </div>
        <div className="accepted-info">
          Accepted by Rimal Katodia - IP logged - PDF snapshot archived
        </div>
      </div>
    </div>
  );
};

export default Agreement;
